import React, { createContext, useContext, useState, useCallback, useMemo } from 'react';

const SearchContext = createContext({
  searchQuery: '',
  setSearchQuery: () => {},
  clearSearch: () => {},
  isSearchOpen: false,
  setIsSearchOpen: () => {},
});

export function SearchProvider({ children }) {
  const [searchQuery, setSearchQuery] = useState('');
  const [isSearchOpen, setIsSearchOpen] = useState(false);

  const clearSearch = useCallback(() => {
    setSearchQuery('');
    setIsSearchOpen(false);
  }, []);

  const value = useMemo(() => ({
    searchQuery,
    setSearchQuery,
    clearSearch,
    isSearchOpen,
    setIsSearchOpen,
  }), [searchQuery, clearSearch, isSearchOpen]);

  return (
    <SearchContext.Provider value={value}>
      {children}
    </SearchContext.Provider>
  );
}

export function useSearch() {
  return useContext(SearchContext);
}
